import RainReportingApi from "../../services/api/RainReporting";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in rain reporting actions :", err);
}

export const createFeedback = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const finalPayload = {
      rainData: { ...payload },
    };
    let response = await RainReportingApi.createFeedback(finalPayload.rainData);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    console.log(payload, err);
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
